enum VesselType {
  TUG = "TUG",
  CONTAINER = "CONTAINER_VESSEL",
  TANKER = "TANKER",
  BULK = "BULK_CARRIER",
  
}

export default VesselType;
